import {Drawer, styled} from "@mui/material";

const DrawerUp = styled(Drawer)(({theme}) => {
  return {
    "& .MuiDrawer-paper": {
      borderTopLeftRadius: "12px",
      borderTopRightRadius: "12px",
      // padding: '24px'
    },
  };
});

export {DrawerUp};
